import { Card, Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import EPrepaidPaymentsHeader from "./_prepaid_payments_header";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Skeleton from "@material-ui/lab/Skeleton";
import { makeStyles } from "@material-ui/core/styles";
import EPrepaidOptions from "./_prepaid_options";
import { useMediaQuery } from "react-responsive";
import { config } from "../../../enviroment";
import { adminService } from "../../../services";
import EFooterSection from "../../e_home-page/e_footer-section/e_footer-section";
const useStyle = makeStyles((theme) => ({
  card: {
    width: "100%",
    height: "100%",
    overflow: "overlay",
  },
  mainGrid: {
    width: "100%",
    height: "96vh",
    padding: "1em",
  },
  mobileMainGrid: {
    width: "100%",
    display: "flex",
    padding: "1em",
    flexDirection: "column",
  },
  paddingCardContent: {
    paddingTop: "0.3rem",
    paddingBottom: "0.3rem !important",
    height: "100%",
  },
  contentGrid: {
    flex: "1 0 0",
    minHeight: 0,
  },
  contentCards: {
    width: "100%",
    height: "100%",
  },
  Tabs: {
    borderBottom: "2px solid " + theme.palette.eTertiary.base,
    marginTop: "1rem",
    minHeight: "30px",
    "& .MuiTabs-indicator": {
      display: "none",
    },
    width: "100%",
  },
  mobileTabWidth: {
    borderBottom: "2px solid " + theme.palette.eTertiary.base,
    marginTop: "1rem",
    minHeight: "30px",
    "& .MuiTabs-indicator": {
      display: "none",
    },
    width: "95vw",
  },
  tabPanel: {
    width: "100%",
    minHeight: "300px",
    flexGrow: "1",
  },
  tabMenuGrid: {
    width: "100%",
  },
  slectedTab: {
    backgroundColor: theme.palette.eTertiary?.base,
    color: theme.palette.eWhite?.base,
    hover: {
      backgroundColor: theme.palette.eTertiary.hover,
    },
  },
  unSelectedTab: {
    backgroundColor: "none",
    color: theme?.palette?.eDark?.base,
  },
  cardsPosition: {
    marginTop: "1rem",
  },
  tabContent: {
    display: "flex",
    flexDirection: "column",
  },
  cardStyle: {
    width: "100%",
    display: "flex",
    marginTop: "1em",
  },
  mobileCard: {
    display: "flex",
    flexDirection: "column",
  },
  margin: {},
}));

const EPrepaidPayments = () => {
  const classes = useStyle();
  const ACTIVE = "Active";
  const [tabVal, setTabValue] = useState(1);
  const { t: labels, ready: labelreadyok } = useTranslation(
    "label-E_ONE_TIME_PAYMENTS"
  );
  const isMobile = useMediaQuery({ query: "(max-width:480px)" });
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setData([]);
    adminService
      .getPaymentTypes("DPDC", ACTIVE)
      .then((res) => {
        if (res) {
          setLoading(false);

          let paymentRes=[...res?.getPaymentTypes,{
            __typename: "PaymentTypeObj",
            PaymentTypeId: 5,
            PaymentGatewayName: "Brac bank",
            Description: "Visa/Master Card (Debit/Credit) via Brac Bank Gateway",
            Url: "https://dpdcbillpay.bracbank.com/bill/",
            Status: "Active",
            Image: "Brac_bank"
        }]
        paymentRes= paymentRes.filter((e)=>{
          return !(e?.PaymentGatewayName=="Brac Bank Ltd." && e?.Image=="E_ROCKET_PAY");
        })
          setData(paymentRes);
        }
      })
      .catch((err) => {
        setData(null);
        setLoading(false);
      });
  }, []);
  const handleChange = (event, value) => {
    setTabValue(value);
  };

  return (
    <Card className={classes.card}>
      {!loading ? (
        <Grid className={isMobile ? classes.mobileMainGrid : classes.mainGrid}>
          <Grid>
            <EPrepaidPaymentsHeader />
          </Grid>
          <Grid className={classes.tabContent}>
            <Tabs
              variant="standard"
              value={tabVal}
              onChange={handleChange}
              className={isMobile ? classes.mobileTabWidth : classes.Tabs}
            >
              <Tab
                style={{
                  minWidth: "13%",
                  minHeight: "25px",
                  transition: "0.25s ease-in-out",
                  borderRadius: " 4px 4px 0 0",
                  fontSize: "1rem",
                  textTransform: "capitalize",
                }}
                label={labelreadyok ? labels("E_OTP_TAB") : ""}
                className={
                  tabVal === 1 ? classes.slectedTab : classes.unSelectedTab
                }
              />
            </Tabs>
          </Grid>
          <Grid className={classes.cardsPosition}>
            {data && (
              <div
                className={isMobile ? classes.mobileCard : classes.cardStyle}
              >
                {data.map((each) => (
                  <EPrepaidOptions key={each.PaymentTypeId} eachRecord={each} />
                ))}
              </div>
            )}
          </Grid>
        </Grid>
      ) : (
        <Skeleton animation="wave" className="heightSkeleton" />
      )}
    <EFooterSection/>
    </Card>
  );
};

export default EPrepaidPayments;
